import instance from "../../axios/axios-user";
import { CircleProps } from "../../redux/slices/circles/circles";
import { API_PATHS } from "../api_paths";

const getListCircles = () => instance(API_PATHS.circle.circles);

const createCircle = (data: CircleProps.createCirclePayload) =>
  instance(API_PATHS.circle.circles, {
    method: "POST",
    data,
  });

const deleteCircle = (data: CircleProps.deleteCirclePayload) =>
  instance(API_PATHS.circle.circles, {
    method: "DELETE",
    data,
  });

const addUserToCircle = (data: CircleProps.addUserToCirclePayload) => {
  const { circle_id, circle_user_id } = data;
  return instance(API_PATHS.circle.circles + circle_id + "/" + circle_user_id, {
    method: "POST",
    data,
  });
};

const removeUserFromCircle = (
  data: CircleProps.removeUserFromCirclePayload
) => {
  const { circle_id, circle_user_id } = data;
  return instance(API_PATHS.circle.circles + circle_id + "/" + circle_user_id, {
    method: "DELETE",
    data,
  });
};

const showCircleDetails = ({ id }: CircleProps.showCircleDetailsPayload) =>
  instance(API_PATHS.circle.circles + id);

const updateCircle = ({ id, name, colour }: CircleProps.updateCirclePayload) =>
  instance(API_PATHS.circle.circles + id, {
    method: "PATCH",
    data: { name, colour },
  });

export const CIRCLE = {
  getListCircles,
  createCircle,
  deleteCircle,
  addUserToCircle,
  removeUserFromCircle,
  showCircleDetails,
  updateCircle,
};
